const enUS = {
  'chat.welcome': 'Hello, I am',
  'chat.prompt.title': 'Do you want to know?',  
  'chat.hot_topics': 'You may be interested in the following questions',
  'chat.input_placeholder': 'Please enter your name',
  'chat.start_chat': 'Confirm',
  'chat.direct_chat': 'Start Chat Directly',
  'chat.direct_chat.label': 'Direct Consultation',
  'chat.initializing': 'Initializing...',
  'chat.username_required': 'Please enter your name',
  'chat.init_failed': 'Initialization failed',
  'img.upload.fail': 'Fail upload image',
  'error.handling.image': 'Error handling image',
  
  // IndependentChat component related
  'video.thumbnail.generate.error': 'Unable to generate thumbnail',
  'video.load.error': 'Video loading failed',
  'qa.create.error': 'Failed to create conversation',
  'file.image.type.error': 'Only image files are allowed!',
  'file.image.size.error': 'Image is too large, please compress it before uploading',
  'file.video.type.error': 'Only video files are allowed!',
  'file.video.size.error': 'Video is too large, please compress it before uploading(maximum 100MB)',
  'file.type.error': 'Unsupported file type, please select image or video files',
  'video.upload.error': 'Video upload failed',
  'video.process.error': 'Video processing error',
  'message.send.success': 'Message sent successfully',
  'message.send.error': 'Send failed',
  'chat.agent.typing': 'Customer service is typing',
  'image.preview.alt': 'Preview image',
  'video.thumbnail.alt': 'Video thumbnail',
  
  // Draggable close button related
  'close.button.title.normal': 'Long press to drag | Click to end chat',
  'close.button.title.dragging': 'Drag to move position',
  'close.chat.confirm.title': 'Confirm Close Chat',
  'close.chat.confirm.content': 'After closing, the current chat will be marked as resolved, and a new conversation will start next time. Are you sure you want to close it?',
  'close.chat.confirm.ok': 'Confirm Close',
  'close.chat.confirm.cancel': 'Cancel',
  'close.chat.success': 'Chat closed, a new conversation will start next time',
  'close.chat.error': 'Failed to close chat, please try again',
  'close.chat.final.title': 'Chat closed successfully',
  'close.chat.already.closed': 'Chat already closed',
  
  // Chat closed page related
  'chat.closed.title': 'Chat Closed',
  'chat.closed.message': 'Current chat has ended, thank you for using',
  
  // Quick question floating related
  'quick.question.title': 'Quick Questions',
  'quick.question.loading': 'Sending...',
  'quick.question.success': 'Quick reply sent successfully',
  'quick.question.error': 'Quick reply failed, please try again',
  'quick.question.send.error': 'Quick reply failed',
  
  // Chat evaluation related
  'evaluation.title': 'Rate this conversation',
  'evaluation.subtitle': 'Your feedback helps us improve our service quality',
  'evaluation.prompt.message': 'Thank you for using our service! Please rate your conversation experience. Your feedback is important to us.',
  'evaluation.completed.prompt.message': 'Thank you for your evaluation! Your feedback is very important to us.',
  'evaluation.rating.1': 'Very Dissatisfied',
  'evaluation.rating.2': 'Dissatisfied',
  'evaluation.rating.3': 'Neutral',
  'evaluation.rating.4': 'Satisfied',
  'evaluation.rating.5': 'Very Satisfied',
  'evaluation.feedback.placeholder': 'Please share your experience or suggestions (optional)',
  'evaluation.skip': 'Skip',
  'evaluation.submit': 'Submit Rating',
  'evaluation.submitted': 'Thank you for your feedback!',
  'evaluation.completed': 'Evaluation Completed',
  'evaluation.your.rating': 'Your Rating',
  'evaluation.your.feedback': 'Your Feedback',
  'evaluation.thank.you': 'Thank you for your valuable feedback, we will continue to improve our service!',
  'evaluation.skipped': 'Evaluation skipped',
  'evaluation.submit.success': 'Evaluation submitted successfully',
  'evaluation.submit.error': 'Failed to submit evaluation',
  
  // Input placeholder states
  'input.placeholder.active': 'Type a message...',
  'input.placeholder.chatting': 'Type a message...',
  'input.placeholder.need-eval': 'Session ended, please complete evaluation',
  'input.placeholder.closed': 'Session ended',
  'input.placeholder.evaluation.enabled': 'Evaluation enabled, waiting for evaluation message',
  
  // Category selector related
  'category.select.title': 'Please Select Service Category',
  'category.select.subtitle': 'Choose the type of issue you want to inquire about, and we will provide you with more precise service',
  'category.deposit': 'Deposit',
  'category.deposit.desc': 'Deposit related inquiries',
  'category.withdraw': 'Withdrawal',
  'category.withdraw.desc': 'Withdrawal related inquiries',
  'category.login_otp': 'Login/OTP',
  'category.login_otp.desc': 'Login and verification code related issues',
  'category.kyc': 'KYC',
  'category.kyc.desc': 'Identity verification related issues',
  'category.welfare_other': 'Welfare & Others',
  'category.welfare_other.desc': 'Welfare activities and other issues',
  'category.continue': 'Continue',
  'category.selected': 'Selected: ',
  'consultation.type': 'Consultation Type: ',
    'category.switch': 'Switch Category',
    'category.switch.success': 'Switch category successfully',
    'category.switch.failed': 'Switch category failed',
    
    // File preview related
    'preview.click': 'Click to preview',
    
    // PDF preview related
    'pdf.preview.title': 'PDF Preview',
    'pdf.preview.open.new.tab': 'Open in New Tab',
    'pdf.preview.download': 'Download',
    
    // Order list related
    'order.amount.label': 'Amount',
    'order.channel.label': 'Channel',
    'order.status.success': 'Success',
    'order.status.failed': 'Failed',
    'order.status.processing': 'Processing',
    'order.list.empty': 'No orders',

    // V2 ending page
    'v2.back_to_game': 'Back to Game',
    'v2.start_new_chat': 'Start New Chat',
    'v2.select_question': 'Please select a question',
    'v2.question_other': 'Other',
};

export default enUS; 